import React from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Injects react-router's `location` as a prop. Sibling of `withNavigate`.
 *
 * Class components cannot call `useLocation`, so five of them carried a byte-identical copy of this
 * wrapper. Each copy returned an anonymous arrow component, which `react/display-name` reports as
 * soon as www/**\/*.tsx is linted on CI — it was not before, because `lint-ci` globbed only `*.ts`
 * and so skipped all 328 .tsx files.
 *
 * `Component` is `any` rather than `React.ComponentType<T>` as in `withNavigate`: the five call
 * sites are `connect()` results whose prop types do not declare `location`, so the generic form
 * would not typecheck without also changing those five components' Props. Kept deliberately as a
 * pure de-duplication — tightening the typing is a separate change.
 */
export const withLocation = (Component: any) => {
    const WithHooks = (props: any) => {
        const location = useLocation();

        return <Component {...props} location={location} />;
    };

    WithHooks.displayName = `withLocation(${Component.displayName || Component.name || 'Component'})`;

    return WithHooks;
};
